"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformIdResponse = exports.isNumber = exports.buildQueryString = void 0;
const buildQueryString = (params) => {
    let queryString = '';
    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value instanceof Array) {
            for (let i = 0; i < value.length; i += 1) {
                queryString = queryString.concat(`&${key}=${value[i]}`);
            }
        }
        else {
            queryString = queryString.concat(`&${key}=${value}`);
        }
    });
    return queryString.substr(1);
};
exports.buildQueryString = buildQueryString;
const isNumber = (value) => typeof value === 'number';
exports.isNumber = isNumber;
const transformIdResponse = (value) => ((0, exports.isNumber)(value) ? value.toString() : value);
exports.transformIdResponse = transformIdResponse;
//# sourceMappingURL=helpers.js.map